import { DataSource, Label, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutIntBillCommentsQuickInfo extends Layout {
    labelTitle: Label;
    panelIntBillComments: Panel;
    sourceBillingComments: DataSource;
    tableIntBillComments: Table;
}
